__turbopack_context__.v({
  "blok-big-title": "CollectionListingPageBlok-module__I40xPW__blok-big-title",
  "blok-subtitle": "CollectionListingPageBlok-module__I40xPW__blok-subtitle",
  "blok-title": "CollectionListingPageBlok-module__I40xPW__blok-title",
  "grid": "CollectionListingPageBlok-module__I40xPW__grid",
  "hero": "CollectionListingPageBlok-module__I40xPW__hero",
  "title": "CollectionListingPageBlok-module__I40xPW__title",
});
